import { call, put } from 'redux-saga/effects';
import {
  fetchChartOfAccountsForOrganisation,
  FetchChartOfAccountsForOrganisationResponse,
} from '../api';
import {
  fetchChartOfAccountsForOrganisationFailure,
  fetchChartOfAccountsForOrganisationSuccess,
} from '../actions';
import { FetchChartOfAccountsForOrganisationRequestAction } from '../types';
import { ApiError } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { logoutRequest } from 'store/auth/actions';
import { MessageData } from 'store/app/types';
import { turnMessageOn } from 'store/app/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { updateOrganisationChartOfAccounts } from 'store/organisation/actions';
import { normalizeCoaAccountRow } from '../models';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundARY-TYPES */
export function* fetchChartOfAccountsForOrganisationSaga(
  action: FetchChartOfAccountsForOrganisationRequestAction
) {
  try {
    let err: ApiError | null;
    const { organisationId } = action.payload;

    const response: FetchChartOfAccountsForOrganisationResponse = yield call(
      fetchChartOfAccountsForOrganisation,
      organisationId
    );

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const accounts = (response?.data?.accounts ?? []).map((row, index) =>
      normalizeCoaAccountRow(row, index)
    );
    // Update chart-of-accounts store (for loading / bookkeeping)
    yield put(
      fetchChartOfAccountsForOrganisationSuccess(organisationId, accounts)
    );
    // Also write the accounts onto the organisation object in the organisation store
    yield put(updateOrganisationChartOfAccounts(organisationId, accounts));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(fetchChartOfAccountsForOrganisationFailure());
  }
}

